import { takeLatest, call, all, put, fork } from 'redux-saga/effects'
import { push } from 'connected-react-router'

import * as actions from '../../actions/actions'

import {plick, plickUpdate} from '../../../api/fileApi'

export default function* plickDetailSaga() {
  yield all([
    fork(watchFetchPlickDetailRequest),
    fork(watchCleanPlickDetailRequest),
    fork(watchPlickDetailUpdate),
    fork(watchPlickDetailFirstNameChangeRequest),
    fork(watchPlickDetailLastNameChangeRequest),
    fork(watchPlickDetailAmountChangeRequest),
    fork(watchPlickDetailTransactionIdChangeRequest),
    fork(watchPlickDetailSenderIdChangeRequest),
    fork(watchPlickDetailSenderFirstnameChangeRequest),
    fork(watchPlickDetailSenderLastnameChangeRequest),
    fork(watchPlickDetailSenderIsCompanyChangeRequest),
    fork(watchPlickDetailSenderCompanyChangeRequest),
    fork(watchPlickDetailSenderDeviceChangeRequest),
    fork(watchPlickDetailSenderAccountChangeRequest),
    fork(watchPlickDetailSenderLanguagePreferencesChangeRequest),
    fork(watchPlickDetailSenderExtraInfoChangeRequest),
    fork(watchPlickDetailReceiverNameChangeRequest),
    fork(watchPlickDetailReceiverDeviceChangeRequest),
    fork(watchPlickDetailReceiverIbanChangeRequest),
    fork(watchPlickDetailReceiverIbanFromBankChangeRequest),
    fork(watchPlickDetailIdBankChangeRequest),
    fork(watchPlickDetailActivationDateChangeRequest),
    fork(watchPlickDetailAmountStringChangeRequest),
    fork(watchPlickDetailCausalChangeRequest),
    fork(watchPlickDetailNotesChangeRequest),
    fork(watchPlickDetailPinChangeRequest),
    fork(watchPlickDetailPinTypeChangeRequest),
    fork(watchPlickDetailIdLogoChangeRequest),
    fork(watchPlickDetailReceiverLanguagePreferencesChangeRequest),
    fork(watchPlickDetailCorrectPlickChangeRequest),
    fork(watchPlickDetailPlickIdFromPortalChangeRequest),
    fork(watchPlickDetailPlickTypeChangeRequest),
    fork(watchPlickDetailReceiverTypeChangeRequest),
    fork(watchPlickDetailBankCroChangeRequest),
    fork(watchPlickDetailBankExecutionDateChangeRequest),
    fork(watchPlickDetailCurrencyDateChangeRequest),
    fork(watchPlickDetailTransferStatusChangeRequest)
  ]);
}

function* watchFetchPlickDetailRequest() {
  yield takeLatest(
    actions.FETCH_PLICK_DETAIL_REQUEST,
    fetchPlickDetailRequest
  )
}

function* fetchPlickDetailRequest(plickData) {

  yield put({ type: actions.PROGRESS_START_REQUEST })
  let value = plickData.value
  try {
    let { data } = yield call(plick, value.bankId,value.fileId, value.plickId )
    yield put({ type: actions.FETCH_PLICK_DETAIL_SUCCESS, value: data })
    yield put(push(`/file/${value.fileId}/plick/${value.plickId}`))
    yield put({ type: actions.PROGRESS_STOP_REQUEST })
  } catch (error) {
    if(error.response){
      yield put({ type: actions.PROGRESS_STOP_REQUEST })
      yield put({ type: actions.FETCH_PLICK_DETAIL_FAILURE, error: error.response })
      yield put({ type: actions.FETCH_ERROR_REQUEST_SERVER, error: error.response })
    }else if(error.request)
    {
      yield put({ type: actions.PROGRESS_STOP_REQUEST })
      yield put({ type: actions.FETCH_ERROR_REQUEST_CLIENT, error: error.response })
    }
  }
}

function* watchCleanPlickDetailRequest() {
  yield takeLatest(
      actions.DETAIL_PLICK_CLEAN_REQUEST,
      cleanPlickDetailRequest
  )
}

function* cleanPlickDetailRequest() {
  yield put({ type: actions.DETAIL_PLICK_CLEAN })
}

function* watchPlickDetailUpdate() {
  yield takeLatest(
      actions.PLICK_DETAIL_UPDATE_REQUEST,
      plickDetailUpdate
  )
}

function* plickDetailUpdate(plickData) {
  yield put({ type: actions.PROGRESS_START_REQUEST })
  let copiedPlickData = Object.assign({}, plickData.value);
  copiedPlickData.senderExtraInfo = JSON.stringify(copiedPlickData.senderExtraInfo).replaceAll("\"", "").replaceAll("{", "").replaceAll("}", "");
  try {
    let { data } = yield call(plickUpdate, copiedPlickData.idBank, copiedPlickData.fileId, copiedPlickData.id, copiedPlickData)
    yield put({ type: actions.PLICK_DETAIL_UPDATE_REQUEST_SUCCESS, value: data })
    yield put({ type: actions.FETCH_PLICKS_REQUEST, value: {file: copiedPlickData.fileId, bankId: copiedPlickData.idBank,page:0,size:10}} )
    if (data === true) {
      yield put({ type: actions.TOGGLE_CORRECTION_MODAL })
    }
    yield put(push(`/file/${copiedPlickData.fileId}/plick/`))
    yield put({ type: actions.PROGRESS_STOP_REQUEST })
  } catch (error) {
    if(error.response){
      yield put({ type: actions.PROGRESS_STOP_REQUEST })
      yield put({ type: actions.PLICK_DETAIL_UPDATE_REQUEST_FAILURE, error: error.response })
      yield put({ type: actions.FETCH_ERROR_REQUEST_SERVER, error: error.response })
    }else if(error.request)
    {
      yield put({ type: actions.PROGRESS_STOP_REQUEST })
      yield put({ type: actions.FETCH_ERROR_REQUEST_CLIENT, error: error.response })
    }
  }
}

function* watchPlickDetailFirstNameChangeRequest() {
  yield takeLatest(
      actions.PLICK_DETAIL_FIRST_NAME_FIELD_CHANGE_REQUEST,
      plickDetailFirstNameChangeRequest
  )
}

function* plickDetailFirstNameChangeRequest(firstName) {
  yield put({ type: actions.PLICK_DETAIL_FIRST_NAME_FIELD_CHANGE, value: firstName.value })
}

function* watchPlickDetailLastNameChangeRequest() {
  yield takeLatest(
      actions.PLICK_DETAIL_LAST_NAME_FIELD_CHANGE_REQUEST,
      plickDetailLastNameChangeRequest
  )
}

function* plickDetailLastNameChangeRequest(lastName) {
  yield put({ type: actions.PLICK_DETAIL_LAST_NAME_FIELD_CHANGE, value: lastName.value })
}

function* watchPlickDetailAmountChangeRequest() {
  yield takeLatest(
      actions.PLICK_DETAIL_AMOUNT_FIELD_CHANGE_REQUEST,
      plickDetailAmountChangeRequest
  )
}

function* plickDetailAmountChangeRequest(firstName) {
  yield put({ type: actions.PLICK_DETAIL_AMOUNT_FIELD_CHANGE, value: firstName.value })
}

function* watchPlickDetailCausalChangeRequest() {
  yield takeLatest(
      actions.PLICK_DETAIL_CAUSAL_FIELD_CHANGE_REQUEST,
      plickDetailCausalChangeRequest
  )
}

function* plickDetailCausalChangeRequest(firstName) {
  yield put({ type: actions.PLICK_DETAIL_CAUSAL_FIELD_CHANGE, value: firstName.value })
}

function* watchPlickDetailReceiverNameChangeRequest() {
  yield takeLatest(
      actions.PLICK_DETAIL_RECEIVER_NAME_FIELD_CHANGE_REQUEST,
      plickDetailReceiverNameChangeRequest
  )
}

function* plickDetailReceiverNameChangeRequest(firstName) {
  yield put({ type: actions.PLICK_DETAIL_RECEIVER_NAME_FIELD_CHANGE, value: firstName.value })
}

function* watchPlickDetailReceiverDeviceChangeRequest() {
  yield takeLatest(
      actions.PLICK_DETAIL_RECEIVER_DEVICE_FIELD_CHANGE_REQUEST,
      plickDetailReceiverDeviceChangeRequest
  )
}

function* plickDetailReceiverDeviceChangeRequest(firstName) {
  yield put({ type: actions.PLICK_DETAIL_RECEIVER_DEVICE_FIELD_CHANGE, value: firstName.value })
}

function* watchPlickDetailActivationDateChangeRequest() {
  yield takeLatest(
      actions.PLICK_DETAIL_ACTIVATION_DATE_FIELD_CHANGE_REQUEST,
      plickDetailActivationDateChangeRequest
  )
}

function* plickDetailActivationDateChangeRequest(firstName) {
  yield put({ type: actions.PLICK_DETAIL_ACTIVATION_DATE_FIELD_CHANGE, value: firstName.value })
}

function* watchPlickDetailSenderCompanyChangeRequest() {
  yield takeLatest(
      actions.PLICK_DETAIL_SENDER_COMPANY_FIELD_CHANGE_REQUEST,
      plickDetailSenderCompanyChangeRequest
  )
}

function* plickDetailSenderCompanyChangeRequest(firstName) {
  yield put({ type: actions.PLICK_DETAIL_SENDER_COMPANY_FIELD_CHANGE, value: firstName.value })
}

function* watchPlickDetailIdBankChangeRequest() {
  yield takeLatest(
      actions.PLICK_DETAIL_ID_BANK_FIELD_CHANGE_REQUEST,
      plickDetailIdBankChangeRequest
  )
}

function* plickDetailIdBankChangeRequest(firstName) {
  yield put({ type: actions.PLICK_DETAIL_ID_BANK_FIELD_CHANGE, value: firstName.value })
}

function* watchPlickDetailSenderDeviceChangeRequest() {
  yield takeLatest(
      actions.PLICK_DETAIL_SENDER_DEVICE_FIELD_CHANGE_REQUEST,
      plickDetailSenderDeviceChangeRequest
  )
}

function* plickDetailSenderDeviceChangeRequest(firstName) {
  yield put({ type: actions.PLICK_DETAIL_SENDER_DEVICE_FIELD_CHANGE, value: firstName.value })
}

function* watchPlickDetailIdLogoChangeRequest() {
  yield takeLatest(
      actions.PLICK_DETAIL_ID_LOGO_FIELD_CHANGE_REQUEST,
      plickDetailIdLogoChangeRequest
  )
}

function* plickDetailIdLogoChangeRequest(firstName) {
  yield put({ type: actions.PLICK_DETAIL_ID_LOGO_FIELD_CHANGE, value: firstName.value })
}

function* watchPlickDetailTransactionIdChangeRequest(){
  yield takeLatest(
      actions.PLICK_DETAIL_TRANSACTION_ID_FIELD_CHANGE_REQUEST,
      plickDetailTransactionIdChangeRequest
  )
}

function* plickDetailTransactionIdChangeRequest(ransactionId) {
  yield put({ type: actions.PLICK_DETAIL_TRANSACTION_ID_FIELD_CHANGE, value: ransactionId.value })
}

function* watchPlickDetailSenderIdChangeRequest(){
  yield takeLatest(
      actions.PLICK_DETAIL_SENDER_ID_FIELD_CHANGE_REQUEST,
      plickDetailSenderIdChangeRequest
  )
}

function* plickDetailSenderIdChangeRequest(senderId) {
  yield put({ type: actions.PLICK_DETAIL_SENDER_ID_FIELD_CHANGE, value: senderId.value })
}

function* watchPlickDetailSenderFirstnameChangeRequest(){
  yield takeLatest(
      actions.PLICK_DETAIL_SENDER_FIRST_NAME_FIELD_CHANGE_REQUEST,
      plickDetailSenderFirstnameChangeRequest
  )
}

function* plickDetailSenderFirstnameChangeRequest(senderFirstname) {
  yield put({ type: actions.PLICK_DETAIL_SENDER_FIRST_NAME_FIELD_CHANGE, value: senderFirstname.value })
}

function* watchPlickDetailSenderLastnameChangeRequest(){
  yield takeLatest(
      actions.PLICK_DETAIL_SENDER_LAST_NAME_FIELD_CHANGE_REQUEST,
      plickDetailSenderLastnameChangeRequest
  )
}

function* plickDetailSenderLastnameChangeRequest(senderLastname) {
  yield put({ type: actions.PLICK_DETAIL_SENDER_LAST_NAME_FIELD_CHANGE, value: senderLastname.value })
}

function* watchPlickDetailSenderIsCompanyChangeRequest(){
  yield takeLatest(
      actions.PLICK_DETAIL_SENDER_IS_COMPANY_FIELD_CHANGE_REQUEST,
      plickDetailSenderIsCompanyChangeRequest
  )
}

function* plickDetailSenderIsCompanyChangeRequest(isCompany) {
  yield put({ type: actions.PLICK_DETAIL_SENDER_IS_COMPANY_FIELD_CHANGE, value: isCompany.value })
}

function* watchPlickDetailSenderAccountChangeRequest(){
  yield takeLatest(
      actions.PLICK_DETAIL_SENDER_ACCOUNT_FIELD_CHANGE_REQUEST,
      plickDetailSenderAccountChangeRequest
  )
}

function* plickDetailSenderAccountChangeRequest(senderAccount) {
  yield put({ type: actions.PLICK_DETAIL_SENDER_ACCOUNT_FIELD_CHANGE, value: senderAccount.value })
}

function* watchPlickDetailSenderLanguagePreferencesChangeRequest(){
  yield takeLatest(
      actions.PLICK_DETAIL_SENDER_LANGUAGE_PREFERENCES_FIELD_CHANGE_REQUEST,
      plickDetailSenderLanguagePreferencesChangeRequest
  )
}

function* plickDetailSenderLanguagePreferencesChangeRequest(senderLanguagePreferences) {
  yield put({ type: actions.PLICK_DETAIL_SENDER_LANGUAGE_PREFERENCES_FIELD_CHANGE, value: senderLanguagePreferences.value })
}

function* watchPlickDetailSenderExtraInfoChangeRequest(){
  yield takeLatest(
      actions.PLICK_DETAIL_SENDER_EXTRA_INFO_FIELD_CHANGE_REQUEST,
      plickDetailSenderExtraInfoChangeRequest
  )
}

function* plickDetailSenderExtraInfoChangeRequest(extraInfo) {
  yield put({ type: actions.PLICK_DETAIL_SENDER_EXTRA_INFO_FIELD_CHANGE, value: extraInfo.value })
}

function* watchPlickDetailReceiverIbanChangeRequest(){
  yield takeLatest(
      actions.PLICK_DETAIL_RECEIVER_IBAN_FIELD_CHANGE_REQUEST,
      plickDetailReceiverIbanChangeRequest
  )
}

function* plickDetailReceiverIbanChangeRequest(receiverIban) {
  yield put({ type: actions.PLICK_DETAIL_RECEIVER_IBAN_FIELD_CHANGE, value: receiverIban.value })
}

function* watchPlickDetailReceiverIbanFromBankChangeRequest(){
  yield takeLatest(
      actions.PLICK_DETAIL_RECEIVER_IBAN_FROM_BANK_FIELD_CHANGE_REQUEST,
      plickDetailReceiverIbanFromBankChangeRequest
  )
}

function* plickDetailReceiverIbanFromBankChangeRequest(receiverIbanFromBank) {
  yield put({ type: actions.PLICK_DETAIL_RECEIVER_IBAN_FROM_BANK_FIELD_CHANGE, value: receiverIbanFromBank.value })
}

function* watchPlickDetailAmountStringChangeRequest(){
  yield takeLatest(
      actions.PLICK_DETAIL_AMOUNT_STRING_FIELD_CHANGE_REQUEST,
      plickDetailAmountStringChangeRequest
  )
}

function* plickDetailAmountStringChangeRequest(amountString) {
  yield put({ type: actions.PLICK_DETAIL_AMOUNT_STRING_FIELD_CHANGE, value: amountString.value })
}

function* watchPlickDetailNotesChangeRequest(){
  yield takeLatest(
      actions.PLICK_DETAIL_NOTES_FIELD_CHANGE_REQUEST,
      plickDetailNotesChangeRequest
  )
}

function* plickDetailNotesChangeRequest(notes) {
  yield put({ type: actions.PLICK_DETAIL_NOTES_FIELD_CHANGE, value: notes.value })
}

function* watchPlickDetailPinChangeRequest(){
  yield takeLatest(
      actions.PLICK_DETAIL_PIN_FIELD_CHANGE_REQUEST,
      plickDetailPinChangeRequest
  )
}

function* plickDetailPinChangeRequest(pin) {
  yield put({ type: actions.PLICK_DETAIL_PIN_FIELD_CHANGE, value: pin.value })
}

function* watchPlickDetailPinTypeChangeRequest(){
  yield takeLatest(
      actions.PLICK_DETAIL_PIN_TYPE_FIELD_CHANGE_REQUEST,
      plickDetailPinTypeChangeRequest
  )
}

function* plickDetailPinTypeChangeRequest(pinType) {
  yield put({ type: actions.PLICK_DETAIL_PIN_TYPE_FIELD_CHANGE, value: pinType.value })
}

function* watchPlickDetailReceiverLanguagePreferencesChangeRequest(){
  yield takeLatest(
      actions.PLICK_DETAIL_RECEIVER_LANGUAGE_PREFERENCES_FIELD_CHANGE_REQUEST,
      plickDetailReceiverLanguagePreferencesChangeRequest
  )
}

function* plickDetailReceiverLanguagePreferencesChangeRequest(receiverLanguagePreferences) {
  yield put({ type: actions.PLICK_DETAIL_RECEIVER_LANGUAGE_PREFERENCES_FIELD_CHANGE, value: receiverLanguagePreferences.value })
}

function* watchPlickDetailCorrectPlickChangeRequest(){
  yield takeLatest(
      actions.PLICK_DETAIL_CORRECT_PLICK_FIELD_CHANGE_REQUEST,
      plickDetailCorrectPlickChangeRequest
  )
}

function* plickDetailCorrectPlickChangeRequest(correctPlick) {
  yield put({ type: actions.PLICK_DETAIL_CORRECT_PLICK_FIELD_CHANGE, value: correctPlick.value })
}

function* watchPlickDetailPlickIdFromPortalChangeRequest(){
  yield takeLatest(
      actions.PLICK_DETAIL_PLICK_ID_FROM_PORTAL_FIELD_CHANGE_REQUEST,
      plickDetailPlickIdFromPortalChangeRequest
  )
}

function* plickDetailPlickIdFromPortalChangeRequest(plickIdFromPortal) {
  yield put({ type: actions.PLICK_DETAIL_PLICK_ID_FROM_PORTAL_FIELD_CHANGE, value: plickIdFromPortal.value })
}

function* watchPlickDetailPlickTypeChangeRequest(){
  yield takeLatest(
      actions.PLICK_DETAIL_PLICK_TYPE_FIELD_CHANGE_REQUEST,
      plickDetailPlickTypeChangeRequest
  )
}

function* plickDetailPlickTypeChangeRequest(plickType) {
  yield put({ type: actions.PLICK_DETAIL_PLICK_TYPE_FIELD_CHANGE, value: plickType.value })
}

function* watchPlickDetailReceiverTypeChangeRequest(){
  yield takeLatest(
      actions.PLICK_DETAIL_RECEIVER_TYPE_FIELD_CHANGE_REQUEST,
      plickDetailReceiverTypeChangeRequest
  )
}

function* plickDetailReceiverTypeChangeRequest(receiverType) {
  yield put({ type: actions.PLICK_DETAIL_RECEIVER_TYPE_FIELD_CHANGE, value: receiverType.value })
}

function* watchPlickDetailBankCroChangeRequest(){
  yield takeLatest(
      actions.PLICK_DETAIL_BANK_CRO_FIELD_CHANGE_REQUEST,
      plickDetailBankCroChangeRequest
  )
}

function* plickDetailBankCroChangeRequest(bankCro) {
  yield put({ type: actions.PLICK_DETAIL_BANK_CRO_FIELD_CHANGE, value: bankCro.value })
}

function* watchPlickDetailBankExecutionDateChangeRequest(){
  yield takeLatest(
      actions.PLICK_DETAIL_BANK_EXECUTION_DATE_FIELD_CHANGE_REQUEST,
      plickDetailBankExecutionDateChangeRequest
  )
}

function* plickDetailBankExecutionDateChangeRequest(executionDate) {
  yield put({ type: actions.PLICK_DETAIL_BANK_EXECUTION_DATE_FIELD_CHANGE, value: executionDate.value })
}

function* watchPlickDetailCurrencyDateChangeRequest(){
  yield takeLatest(
      actions.PLICK_DETAIL_CURRENCY_DATE_FIELD_CHANGE_REQUEST,
      plickDetailCurrencyDateChangeRequest
  )
}

function* plickDetailCurrencyDateChangeRequest(currencyDate) {
  yield put({ type: actions.PLICK_DETAIL_CURRENCY_DATE_FIELD_CHANGE, value: currencyDate.value })
}

function* watchPlickDetailTransferStatusChangeRequest(){
  yield takeLatest(
      actions.PLICK_DETAIL_TRANSFER_STATUS_FIELD_CHANGE_REQUEST,
      plickDetailTransferStatusChangeRequest
  )
}

function* plickDetailTransferStatusChangeRequest(transferStatus) {
  yield put({ type: actions.PLICK_DETAIL_TRANSFER_STATUS_FIELD_CHANGE, value: transferStatus.value })
}